module.exports = __webpack_public_path__ + "static/pima.7a03a823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/pima.png
// module id = 2194
// module chunks = 61762850755587